import React from "react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import usePageMetadata from "@/hooks/use-page-metadata";
import useJsonLd from "@/hooks/use-jsonld";
import { faqPage, service } from "@/lib/seo-schema";
import { FAQS } from "@/components/sections/FAQ";
import Hero from "@/components/Hero";
import LogoBar from "@/components/LogoBar";
import Leistungsuebersicht from "@/components/sections/Leistungsuebersicht";
import Problem from "@/components/sections/Problem";
import Prozess from "@/components/sections/Prozess";
import Nutzen from "@/components/sections/Nutzen";
import ToolProof from "@/components/sections/ToolProof";
import AdFormats from "@/components/sections/AdFormats";
import LiveDemo from "@/components/sections/LiveDemo";
import SeoLandingpages from "@/components/sections/SeoLandingpages";
import Cases from "@/components/sections/Cases";
import Zielgruppen from "@/components/sections/Zielgruppen";
import FAQ from "@/components/sections/FAQ";
import AuditCta from "@/components/sections/AuditCta";

export default function Home() {
  usePageMetadata({
    title: "adsFUX · Aus Fahrzeugdaten einen sichtbaren Vertriebskanal",
    path: "/",
    description:
      "adsFUX ist die Service-Schicht fuer Fahrzeugdaten: Erfassung, Bereinigung, Anreicherung, Google-Vehicle-Ads-Feeds und SEO-Landingpages pro Fahrzeug.",
  });

  useJsonLd([
    service({
      name: "adsFUX Fahrzeugdaten-Service",
      description:
        "Managed Service für Fahrzeugdaten: Erfassung, Bereinigung, Anreicherung, Google-Vehicle-Ads-Feeds und SEO-Landingpages pro Fahrzeug.",
      path: "/",
      serviceType: "Fahrzeugdaten-Management, Google Vehicle Ads Feeds & SEO-Landingpages",
    }),
    faqPage(FAQS),
  ]);

  return (
    <div data-testid="home-page">
      <Header />
      <main>
        <Hero />
        <LogoBar />
        <Leistungsuebersicht />
        <Problem />
        <Prozess />
        <Nutzen />
        <ToolProof />
        <AdFormats />
        <LiveDemo />
        <SeoLandingpages />
        <Cases />
        <Zielgruppen />
        <FAQ />
        <AuditCta />
      </main>
      <Footer />
    </div>
  );
}
